import { motion } from "framer-motion";
import { Mail, MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PageShell } from "@/components/layout/PageShell";

export default function ContactPage() {
  return (
    <PageShell>
      <div className="max-w-3xl mx-auto px-6 lg:px-8 py-24">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
          <span className="text-xs font-mono text-zinc-500 uppercase tracking-[0.2em]">Company</span>
          <h1 className="font-heading font-bold text-4xl sm:text-5xl text-white mt-3 tracking-tight">Contact Us</h1>
          <p className="mt-4 text-base font-mono text-zinc-500">Questions, partnerships, or feedback — we'd love to hear from you.</p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-12">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }}
            data-testid="contact-email-card"
            className="p-8 bg-arena-surface border border-white/[0.06] rounded-md"
          >
            <Mail className="w-5 h-5 text-arena-blue mb-4" />
            <h3 className="font-heading font-semibold text-white text-lg mb-2">Email</h3>
            <p className="text-sm font-mono text-zinc-500 mb-4">For general inquiries and support.</p>
            <a href="mailto:help@qaarena.com" className="text-sm font-mono text-arena-blue hover:text-blue-300 transition-colors">
              help@qaarena.com
            </a>
          </motion.div>

          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.15 }}
            data-testid="contact-discord-card"
            className="p-8 bg-arena-surface border border-white/[0.06] rounded-md"
          >
            <MessageSquare className="w-5 h-5 text-arena-blue mb-4" />
            <h3 className="font-heading font-semibold text-white text-lg mb-2">Discord</h3>
            <p className="text-sm font-mono text-zinc-500 mb-4">Join our community for real-time help.</p>
            <a href="https://discord.gg/qa-arena" target="_blank" rel="noopener noreferrer" className="text-sm font-mono text-arena-blue hover:text-blue-300 transition-colors">
              discord.gg/qa-arena
            </a>
          </motion.div>
        </div>

        <motion.form
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          data-testid="contact-form"
          className="mt-8 p-8 bg-arena-surface border border-white/[0.06] rounded-md space-y-4"
          onSubmit={(e) => e.preventDefault()}
        >
          <h3 className="font-heading font-semibold text-white text-lg mb-2">Send a Message</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <Input data-testid="contact-name-input" placeholder="Name" className="bg-arena-base border-white/[0.08] text-white placeholder:text-zinc-600 font-mono text-sm focus:border-white/[0.2]" />
            <Input data-testid="contact-email-input" placeholder="Email" type="email" className="bg-arena-base border-white/[0.08] text-white placeholder:text-zinc-600 font-mono text-sm focus:border-white/[0.2]" />
          </div>
          <Input data-testid="contact-subject-input" placeholder="Subject" className="bg-arena-base border-white/[0.08] text-white placeholder:text-zinc-600 font-mono text-sm focus:border-white/[0.2]" />
          <textarea
            data-testid="contact-message-input"
            placeholder="Message"
            rows={5}
            className="w-full bg-arena-base border border-white/[0.08] text-white placeholder:text-zinc-600 font-mono text-sm rounded-md px-3 py-2 focus:outline-none focus:border-white/[0.2]"
          />
          <Button data-testid="contact-submit-btn" className="bg-white text-black hover:bg-zinc-200 font-mono text-sm h-10 px-6 rounded-md">
            Send Message
          </Button>
        </motion.form>
      </div>
    </PageShell>
  );
}
